import { Modal } from 'bootstrap'

var loginModal = {
    modal: document.getElementById("loginModal"),
    init: function () {
        let welcomeModal = document.getElementById('welcomeModal');
        if(welcomeModal) {
            let myWelcomeModal = new Modal(welcomeModal);
            myWelcomeModal.show();
        }
        if (this.modal) {
            let userModal = this.modal.parentElement;
            if(userModal.classList.contains('has-error')) {
                let myModal = new Modal(userModal);
                myModal.show();
            }
            const showLogins = this.modal.querySelectorAll('[data-nav="loginModalShowLogin"]');
            showLogins.forEach(el => el.addEventListener("click", loginModal.showLogin));

            const showRegisters = this.modal.querySelectorAll('[data-nav="loginModalShowRegister"]');
            showRegisters.forEach(el => el.addEventListener("click", loginModal.showRegister));

            const showForgottenPwd = document.getElementById("showForgottenPassword");
            showForgottenPwd.addEventListener("click", loginModal.showForgottenPassword);

            const hideForgottenPwd = document.getElementById("hideForgottenPassword");
            hideForgottenPwd.addEventListener("click", loginModal.hideForgottenPassword);

            userModal.addEventListener('hidden.bs.modal', function (_event) {
                loginModal.showLogin();
            });
        }
    },
    showLogin: function () {
        const modalSlides = loginModal.modal.querySelectorAll("section");
        modalSlides.forEach(el => el.classList.add("hide"));
        document.getElementById("loginModalLogin").classList.remove("hide");
    },
    showRegister: function () {
        const modalSlides = loginModal.modal.querySelectorAll("section");
        modalSlides.forEach(el => el.classList.add("hide"));
        document.getElementById("loginModalRegister").classList.remove("hide");
    },
    showForgottenPassword: function() {
        document.getElementById("loginForm").classList.add("hide");
        document.getElementById("forgottenPassword").classList.remove("hide");
    },
    hideForgottenPassword: function() {
        document.getElementById("loginForm").classList.remove("hide");
        document.getElementById("forgottenPassword").classList.add("hide");        
    }
}

export default loginModal;